import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/media";

interface NewsCardProps {
  item: NewsItem;
  variant?: "list" | "grid";
}

export default function NewsCard({ item, variant = "list" }: NewsCardProps) {
  if (variant === "grid") {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group flex flex-col bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors cursor-pointer h-full"
      >
        <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} - 影视资讯`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-[11px] font-semibold bg-secondary-500 text-background-50">
            {item.category}
          </span>
        </div>
        <div className="p-4 flex flex-col flex-1">
          <h3 className="text-sm md:text-base font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors">
            {item.title}
          </h3>
          <p className="mt-2 text-xs md:text-sm text-foreground-600 line-clamp-2 flex-1">
            {item.summary}
          </p>
          <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
            <span>{item.author}</span>
            <span>{item.publishedAt}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex gap-4 p-3 bg-background-50 border border-background-200 rounded-lg hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-28 h-20 md:w-40 md:h-24 flex-shrink-0 overflow-hidden rounded-md bg-background-200">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 影视资讯`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="min-w-0 flex flex-col justify-center">
        <div className="flex items-center gap-2 mb-1">
          <span className="px-2 py-0.5 rounded-md text-[11px] font-semibold bg-secondary-100 text-secondary-900">
            {item.category}
          </span>
          <span className="text-xs text-foreground-500 hidden sm:inline">{item.publishedAt}</span>
        </div>
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 leading-snug line-clamp-1 group-hover:text-primary-500 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1 text-xs md:text-sm text-foreground-600 line-clamp-2 hidden sm:block">
          {item.summary}
        </p>
      </div>
    </Link>
  );
}